import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classnames from 'classnames';
import { FDStack } from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const useStyles = buildUseStyles('EstatePlanningProfileSubpageStepNumberStep', (theme) => (
  {
    container: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: theme.spacing(1.5),
      backgroundColor: theme.palette.facet.primaryBlueMuted,
      flexShrink: 0,
    },
    containerComplete: {
      backgroundColor: theme.palette.facet.mediumGray,
    },
    containerDisabled: {
      backgroundColor: theme.palette.facet.mediumGray,
    },
    text: {
      lineHeight: `${theme.spacing(3)}px`,
    },
  }));

const EstatePlanningProfileSubpageStepNumber = ({
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const state = resource.attr('state');

  return (
    <div className={classnames(classes.container, {
      [classes.containerComplete]: state === 'complete',
      [classes.containerDisabled]: state === 'disabled',
    })}
    >
      <FDStack justifyContent={'center'} alignItems={'center'} direction={'column'}>
        <Typography className={classes.text} color={'white'}>{resource.attr('stepNumber')}</Typography>
      </FDStack>
    </div>
  );
};

EstatePlanningProfileSubpageStepNumber.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default EstatePlanningProfileSubpageStepNumber;
